"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenuItem = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ContextItemNested_1 = require("../ContextItemNested");
const context_1 = require("./context");
const useSyncStore_1 = require("../../../hooks/useSyncStore");
const ArgsPane_1 = require("../ArgsPane");
const MoveToViewport_1 = require("../../../utils/popup/MoveToViewport");
const ContextMenuItem = (props) => {
    const { item, path, open, openPanel, renderPane } = props;
    const [t] = (0, use_t_1.useT)();
    const state = (0, context_1.useContextMenu)();
    const active = !!(0, useSyncStore_1.useSyncStoreOpt)(item.active);
    const disabled = !!(0, useSyncStore_1.useSyncStoreOpt)(item.disabled);
    const visibleStore = (0, useSyncStore_1.useSyncStoreOpt)(item.visible);
    if (item.visible && visibleStore === false)
        return null;
    const id = item.id ?? item.name;
    const children = !!item.children && !!item.children.length ? item.children : void 0;
    const hasPane = !!item.pane;
    const hasPanel = !!item.panel;
    const hasArgs = !!item.params?.length;
    const popupArgs = hasArgs && !!item.popupArgs;
    const display = item.display?.() ?? t(item.name);
    if (item.raw)
        return item.raw();
    const popupArgsRenderPane = popupArgs
        ? () => (React.createElement(MoveToViewport_1.MoveToViewport, null,
            React.createElement(ArgsPane_1.ArgsPane, { item: item, params: item.params, minWidth: item.minWidth, onCancel: () => openPanel?.deselect(), onSubmit: item.onSubmit
                    ? (list, map) => {
                        item.onSubmit?.(list, map);
                        state.onclose?.();
                    }
                    : undefined, onChange: item.onChange })))
        : undefined;
    const showsPopup = !!children || hasPane || popupArgs || hasPanel;
    return (React.createElement("div", { "data-menu-row": true, "data-menu-id": id },
        React.createElement(ContextItemNested_1.ContextItemNested, { key: item.id || item.name, open: open, inset: state.props.inset, more: item.more, nested: showsPopup, selected: active, disabled: disabled, icon: item.icon?.() ??
                (item.iconBig ? (React.createElement("div", { style: { transformOrigin: '0 0', transform: 'scale(.25)' } }, item.iconBig?.())) : (void 0)), right: item.control?.() ?? item.right?.(), control: !!item.control, danger: item.danger, mono: item.mono, onClick: popupArgs
                ? () => openPanel?.forceSelect(id)
                : hasArgs
                    ? () => {
                        state.selectArgs(path, item);
                    }
                    : hasPanel
                        ? () => {
                            state.select(path, item);
                        }
                        : hasPane
                            ? () => {
                                state.select(path, item);
                            }
                            : item.onSelect
                                ? (event) => state.execute(item, event)
                                : children
                                    ? () => {
                                        state.select(path, item);
                                    }
                                    : void 0, onMouseDown: item.onMouseDown, renderPane: popupArgsRenderPane ?? (showsPopup && renderPane ? renderPane : void 0), onMouseEnter: () => openPanel?.onMouseMove(id), onMouseMove: () => openPanel?.onMouseMove(id), onMouseLeave: openPanel?.onMouseLeave, role: "menuitem", tabIndex: -1, "aria-haspopup": showsPopup ? 'menu' : undefined, "aria-expanded": showsPopup ? open : undefined, "aria-disabled": disabled || undefined }, display)));
};
exports.ContextMenuItem = ContextMenuItem;
